/**
 * Reviews section
 * - Swiper slider initialization
 * - Read More / Read Less toggle per card
 *
 * Equal-height slides:
 *   .swiper-wrapper  → align-items: stretch  (SCSS)
 *   .swiper-slide    → height: auto          (SCSS)
 *   .reviews-card    → height: 100%          (SCSS)
 *   This makes all visible slides the same height (tallest wins).
 *
 * Independent expand:
 *   When "Read More" is clicked, only that specific card grows
 *   by adding .is-expanded which sets height: auto, breaking
 *   it out of the equal-height constraint.
 */

export function reviews() {
  const section = document.getElementById('reviews');
  if (!section) return;

  const sliderEl = section.querySelector('.reviews-slider');
  if (!sliderEl) return;

  const prevBtn = section.querySelector('.reviews-nav__btn--prev');
  const nextBtn = section.querySelector('.reviews-nav__btn--next');

  // -----------------------------------------------
  // Swiper initialization
  // -----------------------------------------------
  if (typeof Swiper === 'undefined') return;

  const swiper = new Swiper(sliderEl, {
    loop: true,
    speed: 600,
    slidesPerView: 1,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1440: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
    navigation: {
      prevEl: prevBtn || null,
      nextEl: nextBtn || null,
    },
  });

  // -----------------------------------------------
  // Read More / Read Less toggle
  // -----------------------------------------------
  const cards = section.querySelectorAll('.reviews-card');
  if (!cards || cards.length === 0) return;

  cards.forEach((card) => {
    const textEl = card.querySelector('.reviews-card__text');
    const toggleBtn = card.querySelector('.reviews-card__toggle');

    if (!textEl || !toggleBtn) return;

    // Measure line height to calculate 6-line threshold
    const lineHeight = parseFloat(getComputedStyle(textEl).lineHeight);
    const maxLines = 6;
    const maxHeight = lineHeight * maxLines;

    // Get full (unclamped) height first, then apply clamp
    const fullHeight = textEl.scrollHeight;

    if (fullHeight > maxHeight + 2) {
      // Text exceeds 6 lines — apply clamp and show toggle
      textEl.classList.add('is-clamped');
      toggleBtn.hidden = false;

      toggleBtn.addEventListener('click', () => {
        const isClamped = textEl.classList.contains('is-clamped');

        if (isClamped) {
          textEl.classList.remove('is-clamped');
          card.classList.add('is-expanded');
          toggleBtn.textContent = 'Read Less';
        } else {
          textEl.classList.add('is-clamped');
          card.classList.remove('is-expanded');
          toggleBtn.textContent = 'Read More';
        }
      });
    }
    // If text fits within 6 lines: no clamp, button stays hidden
  });
}